import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Radio } from '@codex/basics';

const MarketGroup = styled.div`
  font-size: 13px;
  padding: 5px 0px;

  ${({ isMobile }) =>
    isMobile &&
    `border-top: solid 1px #CCC;
    width: 88%;
    margin-left: 20px;
    padding: 10px 2px;
  `};

  div[class*='Radio__Bullet'] {
    height: 19px;
    width: 19px;
    &:before {
      top: 2px;
      left: 2px;
      width: 13px;
      height: 13px;
      border-radius: 51%;
      background-color: #4e8130;
    }
  }
`;

const MarketLabel = styled.div`
  font-weight: bold;
  margin-bottom: 5px;

  ${({ isMobile }) => isMobile && 'margin-bottom: 3px;'};
`;

const RadioLabel = styled.span`
  ${({ disabled, theme }) => disabled && `color: ${theme.colors.shades[5]};`};
`;

const SegmentFilters = ({ segmentsData, onFilterClick, isMobile }) => {
  const marketNames = [...new Set(Array.from(segmentsData, (sd) => sd.marketName))];

  const marketsData = marketNames.map((marketName) => {
    const marketSegments = [];
    for (let i = 0; i < segmentsData.length; i++) {
      if (marketName === segmentsData[i].marketName) {
        marketSegments.push(segmentsData[i]);
      }
    }
    return {
      marketName: marketName,
      segments: marketSegments
    };
  });

  const marketsGroup = marketsData.map((marketData) => {
    const segmentsRadios = marketData.segments.map((segment) => (
      <Radio
        name={'segmentsFilters'}
        key={segment.label}
        value={segment.label}
        checked={segment.selected}
        disabled={segment.count === '0'}
        onChange={(e) => {
          e.preventDefault();
          if (segment.count !== '0') {
            onFilterClick(segment.value, segment.selected);
          }
        }}
      >
        <RadioLabel disabled={segment.count === '0'}>
          {segment.label}
          {' '}
          (
          {segment.count}
          )
        </RadioLabel>
      </Radio>
    ));

    return (
      <MarketGroup key={marketData.marketName} isMobile={isMobile}>
        <MarketLabel isMobile={isMobile}>{marketData.marketName}</MarketLabel>
        {segmentsRadios}
      </MarketGroup>
    );
  });

  return <>{marketsGroup}</>;
};

SegmentFilters.propTypes = {
  segmentsData: PropTypes.arrayOf(
    PropTypes.shape({
      marketId: PropTypes.number.isRequired,
      marketName: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired
    })
  ).isRequired,
  onFilterClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool
};

SegmentFilters.defaultProps = {
  isMobile: false
};

export default SegmentFilters;
